import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

const paths = {
  list: "/",
};

type PrescriptionPathDefinitions = {
  list: {};
};

export type PrescriptionPaths = MakePaths<PrescriptionPathDefinitions>;

export const usePrescriptionRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.list,
      element: () => import("../components/PrescriptionsPage"),
      pageName: "prescriptions",
    },
  ]);
};

export const makePrescriptionUrls = (base: string) => {
  return makeUrls<PrescriptionPathDefinitions>(base, {
    list: { path: paths.list },
  });
};
